import { render, staticRenderFns } from "./publicTopbar.vue?vue&type=template&id=6345b68e&scoped=true"
import script from "./publicTopbar.vue?vue&type=script&lang=js"
export * from "./publicTopbar.vue?vue&type=script&lang=js"
import style0 from "./publicTopbar.vue?vue&type=style&index=0&id=6345b68e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6345b68e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\01_Projects\\zr_code\\exam_registration_api\\exam-registration-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6345b68e')) {
      api.createRecord('6345b68e', component.options)
    } else {
      api.reload('6345b68e', component.options)
    }
    module.hot.accept("./publicTopbar.vue?vue&type=template&id=6345b68e&scoped=true", function () {
      api.rerender('6345b68e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commonality/publicTopbar.vue"
export default component.exports